import { FC, useEffect, useRef } from 'react'
import { PoiEditor } from './PoiEditor.tsx'
import { useMap } from 'react-leaflet'
import L from 'leaflet'
import { PoiList } from './poi/PoiList.tsx'
import { Sidebar } from './general/layout/Sidebar.tsx'
import { SettingsPopover } from './general/settings/SettingsPopover.tsx'

type MenuProps = {
    isCategorized?: boolean
}

export const Menu: FC<MenuProps> = ({ isCategorized }) => {
    const menuRef = useRef<HTMLDivElement>(null)
    const map = useMap()

    useEffect(() => {
        // disable MapContainer clicks over menu
        L.DomEvent.disableClickPropagation(menuRef.current)
        L.DomEvent.disableScrollPropagation(menuRef.current)
    }, [menuRef])

    return (
        <div
            id={'mm-menu'}
            ref={menuRef}
            className={'leaflet-control-container text-base z-1000'}
            onMouseEnter={() => {
                map.dragging.disable()
            }}
            onMouseLeave={() => {
                map.dragging.enable()
            }}
        >
            <Sidebar>
                {/*left column*/}
                <div
                    className={
                        'bg-mm-bg/95 backdrop-blur-lg saturate-200 flex flex-3 flex-col min-w-56.25 max-w-56.25 border-r'
                    }
                >
                    <PoiList isCategorized={isCategorized} />

                    <SettingsPopover />
                </div>

                {/*right column*/}
                <PoiEditor />
            </Sidebar>
        </div>
    )
}
